import { Notification } from 'baseui/notification';
import CategoryProgressList from './CategoryProgressList';
import { HEADER_IMAGES } from './constants';
import {
  HeaderRow,
  HeaderLeft,
  Avatar,
  NameColumn,
  UserName,
  DateRow,
  CalendarIcon,
  DateText,
  ContentArea,
  NotificationWrapper,
} from './styled-components';
import useGamification from './useGamification';

const Gamification = ({
  cardStyle,
  isExternal,
  userAchievements = [],
}) => {
   const { handleCategoryClick, notification, categories, firstname, name, isLocalOrStaging } = useGamification({userAchievements});

  // Disable production until fully ready
  if (!isLocalOrStaging || isExternal) {
    return null
  }

  return (
    <div className={cardStyle}>
        <HeaderRow>
          <HeaderLeft>
            <Avatar src={HEADER_IMAGES.avatar} alt="Avatar" />
            <NameColumn>
              <UserName>{firstname} {name}</UserName>
              <DateRow>
                <CalendarIcon src={HEADER_IMAGES.calendarIcon} alt="" />
                <DateText>{new Date().toLocaleDateString()}</DateText>
              </DateRow>
            </NameColumn>
          </HeaderLeft>
        </HeaderRow>

        <ContentArea>
          <CategoryProgressList
            categories={categories}
            onCategoryClick={handleCategoryClick}
          />
        </ContentArea>

      {/* Notification toast */}
      {notification && (
        <NotificationWrapper>
          <Notification kind={notification.kind} closeable>
            {notification.message}
          </Notification>
        </NotificationWrapper>
      )}
    </div>
  );
};

export default Gamification;
